import { render } from "./addNotice.vue?vue&type=template&id=f49f87f2&scoped=true"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"

import "./addNotice.vue?vue&type=style&index=0&id=f49f87f2&scoped=true&lang=css"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49f87f2"]])

export default __exports__